module.exports = __webpack_public_path__ + "fonts/sourcesansprolight.4849a281.ttf";